import type { LinksData } from '@jouzen/ecom-components/v3/data/types';
import cloneDeep from 'lodash/cloneDeep';
import { type RichTranslationValues, useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import getLocaleFormatting, {
  getLocaleFormatString,
} from '@/utils/getLocaleFormatting';

export const useLocalizeLinks = (
  statsigLinks: LinksData[] = [],
  tValues: RichTranslationValues = {},
): LinksData[] => {
  const t = useTranslations();
  const _statsigLinks = cloneDeep(statsigLinks);
  const _tValues: RichTranslationValues = {
    ...getLocaleFormatting,
    ...getLocaleFormatString,
    ...tValues,
  };

  return _statsigLinks.map((links) => {
    if (links.links) {
      for (const link of links.links) {
        link.label = t.rich(link.label as MessageKey, _tValues) as string;
      }
    }
    if (links.link) {
      links.link.label = t.rich(
        links.link.label as MessageKey,
        _tValues,
      ) as string;
      if (links.link.overlay) {
        links.link.overlay.title = t.rich(
          links.link.overlay.title as MessageKey,
          _tValues,
        ) as string;
        if (links.link.overlay.description) {
          links.link.overlay.description = t.rich(
            links.link.overlay.description as MessageKey,
            _tValues,
          ) as string;
        }
      }
    }
    links.title = t.rich(links.title as MessageKey, _tValues) as string;
    return links;
  });
};
